export const districtOptions = [
  { label: "Bobirwa", value: "Bobirwa" },
  { label: "Boteti", value: "Boteti" },
  { label: "Charles Hill", value: "Charles Hill" },
  { label: "Chobe", value: "Chobe" },
  { label: "Francistown", value: "Francistown" },
  { label: "Gaborone", value: "Gaborone" },
  { label: "Ghanzi", value: "Ghanzi" },
  { label: "Goodhope", value: "Goodhope" },
  { label: "Hukuntsi", value: "Hukuntsi" },
  { label: "Kanye", value: "Kanye" },
  { label: "Kgatleng", value: "Kgatleng" },
  { label: "Kweneng", value: "Kweneng" },
  { label: "Letlhakeng", value: "Letlhakeng" },
  { label: "Mabutsane", value: "Mabutsane" },
  { label: "Mahalapye", value: "Mahalapye" },
  { label: "Mogoditshane–Thamaga", value: "Mogoditshane–Thamaga" },
  { label: "Moshupa", value: "Moshupa" },
  { label: "North East", value: "North East" },
  { label: "North West", value: "North West" },
  { label: "Okavango", value: "Okavango" },
  { label: "Palapye", value: "Palapye" },
  { label: "Ramotswa", value: "Ramotswa" },
  { label: "Selebi-Phikwe", value: "Selebi-Phikwe" },
  { label: "Serowe", value: "Serowe" },
  { label: "Tonota", value: "Tonota" },
  { label: "Tlokweng", value: "Tlokweng" },
  { label: "Tsabong", value: "Tsabong" },
  { label: "Tutume", value: "Tutume" },
];
